import {
    checkboxInput,
    dateTimePicker,
    doubleInput,
    integerInput,
} from '../../inputs/controls'
import { coreSettingsErrors } from './coreSettingsErrors'
import { TimeFormats } from '../../models/DateTime/types'

export const getBackupSettingsControlDescriptors = (state: any) => [
    checkboxInput(
        'is_backup_enabled',
        '',
        'Enable backup',
        '',
        false,
        '',
        false,
        false
    ),
    integerInput({
        name: 'backup_interval_days',
        isColumn: true,
        label: 'Interval days',
        errMsg: coreSettingsErrors.backupIntervalDays(state),
        className: 'w-100',
        placeholder: 'Default value',
        tooltipText:
            'Frequency of backup creation. A value of 1 means daily backups',
    }),
    dateTimePicker(
        'start_time',
        {
            timeFormat: TimeFormats.HOURS_MINUTES_SECONDS,
            showTimeSelect: true,
            showTimeSelectOnly: true,
            timeSource: 'product',
            className: 'w-100',
            isColumn: true,
            description: `
                <p class="paragraph-desc">The scheduled backup starting time</p>
                <hr>
                <p class="paragraph-desc">
                    <span class="info-box-desc">Attention:</span> <span>Backup behaviour is affected by daylight saving time changes and depends on the set time:</span>
                    <ul class="list-ul-desc">
                        <li><span class="highlight-desc">Daylight saving time</span> (clock moves forward): Any backup scheduled between <span class="highlight-desc">02:00</span> and <span class="highlight-desc">03:00</span> will be skipped on that day.</li>
                        <li><span class="highlight-desc">Return to standard time</span> (clock moves backwards): Any backup scheduled between <span class="highlight-desc">02:00</span> and <span class="highlight-desc">03:00</span> will run once, at the first occurrence of that time.</li>
                    </ul>
                </p>
                <p class="paragraph-desc">To ensure scheduled backups run consistently, avoid scheduling backups between 02:00 and 03:00 in time zones with daylight saving time.</p>
                <p class="paragraph-desc">
                    <span class="info-box-desc">Note:</span> <span> If not specified, product default value will be used.</span> 
                </p>
            `,
            placeholder: 'Default value',
        },
        false,
        false
    ),
    doubleInput({
        name: 'storage_limit_gb',
        isColumn: true,
        label: 'Storage limit gb',
        errMsg: coreSettingsErrors.storageLimitGb(state),
        className: 'w-100',
        tooltipText:
            'Maximum disk space allowed for storing backups. If the total size exceeds this value, the oldest backups will be removed automatically',
        placeholder: 'Default value',
    }),
    integerInput({
        name: 'lifetime_days',
        isColumn: true,
        label: 'Lifetime days',
        errMsg: coreSettingsErrors.lifetimeDays(state),
        className: 'w-100',
        tooltipText:
            'Maximum number of days backups are retained. Backups may be deleted earlier if their total size exceeds the Storage limit value',
        placeholder: 'Default value',
    }),
    integerInput({
        name: 'retry_attempts',
        isColumn: true,
        label: 'Retry attempts',
        errMsg: coreSettingsErrors.retryAttempts(state),
        className: 'w-100',
        tooltipText: 'Number of database backup attempts',
        placeholder: 'Default value',
    }),
    integerInput({
        name: 'retry_delay_sec',
        isColumn: true,
        label: 'Retry delay sec',
        errMsg: coreSettingsErrors.retryDelaySecBackup(state),
        className: 'w-100',
        tooltipText:
            'Delay in seconds before retrying backup creation after an error',
        placeholder: 'Default value',
    }),
]
